import { Message } from "../models/Message";

export type MessagePart = {
    type: 'text' | 'image' | 'video' | 'file' | 'gift' | 'token';
    content: string;
  };
  
  export const composeMessage = (parts: MessagePart[]): string => {
    return parts.map(part => {
      const prefix = {
        text: '/t:',
        image: '/i:',
        video: '/v:',
        file: '/f:',
        gift: '/g:',
        token: '/n:'
      }[part.type];
      return `${prefix}${part.content}`;
    }).join('');
  };
  
  export const parseMessage = (compositeMessage: string): MessagePart[] => {
  const parts: MessagePart[] = [];
  const regex = /\/([tivfgn]):([^\/]*)(?=\/|$)/g;
  let match;

  while ((match = regex.exec(compositeMessage)) !== null) {
    const typeMap = {
      t: 'text',
      i: 'image',
      v: 'video',
      f: 'file',
      g: 'gift',
      n: 'token'
    };

    // console.log("Match found:", match); // Debugging line

    parts.push({
      type: typeMap[match[1] as keyof typeof typeMap] as MessagePart['type'],
      content: match[2]
    });
  }

  return parts;
};
  
  // Helper to determine primary message type for the bubble
  export const getPrimaryMessageType = (parts: MessagePart[]): Message['messageType'] => {
    // Priority order for display
    const priority = ['image', 'video', 'file', 'gift', 'token', 'text'];
    for (const type of priority) {
      if (parts.some(part => part.type === type)) {
        return type as Message['messageType'];
      }
    }
    return 'text';
  };